<template>
  <div v-show="!showSelectFeatureDialog">
    <span class="maptooltip primary text--white elevation-2"></span>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import IdentifyService from "../../../services/IdentifyService";
import { mapState } from "vuex";
export default {
  name: "MapTooltip",
  props: ["kartview", "selectionlayer", "tidsrom"],
  data() {
    return {
      params: {
        returnGeometry: false,
      },
      tooltip: null,
      timeout: null,
      identifyService: null,
    };
  },
  computed: {
    ...mapState([
      "kart",
      "queryExpression",
      "showSelectFeatureDialog",
      "queryExpressionStationsFromOtherActors",
      "showStationsFromOtherActors",
    ]),
  },
  methods: {
    showTooltip: function(evt) {
      clearTimeout(this.timeout);
      this.tooltip.style.display = "none";
      this.timeout = setTimeout(() => {
        var point = this.kartview.toMap({ x: evt.x, y: evt.y });
        evt.mapPoint = point;
        this.tooltip.style.left = evt.native.pageX - 420 + "px";
        this.tooltip.style.top = evt.native.pageY - 50 + "px";
        this.tooltip.style.color = "white";
        this.tooltip.style.background = "white";
        this.params.returnGeometry = false;
        this.identifyService = new IdentifyService(
          this.params,
          this.kartview,
          this.selectionlayer,
          this.kart.kartlag
        );
        this.identifyService
          .executeIdentifyTask(
            evt,
            this.queryExpression,
            this.queryExpressionStationsFromOtherActors,
            this.showStationsFromOtherActors,
            true
          )
          .then((result) => {
            if (result.response.length > 0) {
              this.tooltip.innerHTML =
                "<strong>" +
                result.response[0].attributes.stasjonNavn +
                " (" +
                result.response[0].attributes.stasjonNr +
                ")" +
                (result.response.length > 1
                  ? " +" + (result.response.length - 1)
                  : "") +
                "</strong>";
              this.tooltip.style.display = "block";
              this.tooltip.style.color = "white";
            }
          });
      }, 500);
    },
    setIdentifyParams: function() {
      loadModules(["esri/tasks/support/IdentifyParameters"]).then(
        ([IdentifyParameters]) => {
          this.params = new IdentifyParameters();
          this.params.tolerance = 10;
          this.params.layerIds = [0];
          this.params.layerOption = "visible";
          this.params.returnGeometry = true;
          this.params.width = this.kartview.width;
          this.params.height = this.kartview.height;
        }
      );
    },
  },
  mounted: function() {
    loadModules(["dojo/on"]).then(([on]) => {
      this.tooltip = document.querySelectorAll(".maptooltip")[0];

      on(this.kartview, "pointer-move", (evt) => {
        this.showTooltip(evt);
      });
      this.setIdentifyParams();
    });
  },
};
</script>
<style>
.maptooltip {
  display: none;
  margin-left: 30px;
  padding: 10px;
  margin-top: -50px;
  border-radius: 5px;
  position: absolute;

  width: auto;
  height: auto;
  -webkit-animation: fadein 300ms;
  animation: fadein 300ms;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
